import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { DxPopupComponent } from 'devextreme-angular';
import { take } from 'rxjs/operators';
import { EventService } from 'src/app/services/event.service';
import { SessionContextService } from 'src/app/services/session-context.service';
import { TerminalService } from 'src/app/services/terminal.service';


export class TillOpenResult {
  result: boolean = false;
  returnUrl: string = "";
}
export class TillFloatInfo {
  TerminalName: string = "";
  CashFloatTotal: number = 0.0;
}

@Component({
  selector: 'app-open-till',
  templateUrl: './open-till.component.html',
  styleUrls: ['./open-till.component.css']
})
export class OpenTillComponent {
  @Output() CloseDlg: EventEmitter<TillOpenResult> = new EventEmitter<TillOpenResult>();
  @ViewChild(DxPopupComponent) popup: DxPopupComponent;
  floatInfo: TillFloatInfo = new TillFloatInfo();
  tillOpenResult: TillOpenResult = new TillOpenResult();

  OKButtonOptions = {
    text: 'OK',
    onClick: this.btnOk.bind(this)
  };

  constructor(private terminalService: TerminalService, private session: SessionContextService, private events: EventService) {
  }

  public show(returnUrl: string) {

    this.tillOpenResult.returnUrl = returnUrl;

    // If terminal does not have a till drawer connected then return.
    if (this.terminalService.DoesTerminalHaveTill() == false) {
      this.tillOpenResult.result = false;
      this.CloseDlg.emit(this.tillOpenResult);
      return;
    }

    // if the terminal has till drawer and terminal is already open then return
    this.terminalService
      .IsTerminalOpen()
      .pipe(take(1))
      .subscribe((r) => {
        if (r == true) {
          this.tillOpenResult.result = true;
          this.CloseDlg.emit(this.tillOpenResult);
          return;
        } else {
          let selectedTerminal = this.session.GetSelectedTerminal();
          if (selectedTerminal && selectedTerminal.TillConnected) {
            // Pop cash drawer and Show Dialog
            this.events.OpenTillDrawer(selectedTerminal.TillDrawerId);
            this.popup.visible = true;
            this.floatInfo.TerminalName = selectedTerminal.Name;
            this.floatInfo.CashFloatTotal = 0.0;
          } else {
            this.tillOpenResult.result = false;
            this.CloseDlg.emit(this.tillOpenResult);
            return;
          }
        }
      });
  }

  btnOk(e) {
    // Open Till.
    this.terminalService
      .OpenTerminal(this.floatInfo.CashFloatTotal)
      .pipe(take(1))
      .subscribe((r) => {
        this.tillOpenResult.result = r;
        this.CloseDlg.emit(this.tillOpenResult);
      });
  }
}
